import { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../home/components/Footer';

export default function CareersPage() {
  const [selectedDepartment, setSelectedDepartment] = useState('全部');

  const departments = ['全部', '技术开发', '产品设计', '销售', '人力资源'];

  const jobOpenings = [
    {
      id: 1,
      title: '高级前端开发工程师',
      department: '技术开发',
      location: '广州',
      type: '全职',
      experience: '3-5年',
      description: '负责前端产品的开发和维护，参与产品架构设计，优化用户体验。',
      requirements: [
        '熟练掌握React、TypeScript、HTML5、CSS3',
        '具备良好的代码规范和团队协作能力',
        '有大型项目开发经验优先',
        '对用户体验有深入理解'
      ],
      benefits: ['五险一金', '弹性工作', '技术培训', '年终奖金']
    },
    {
      id: 2,
      title: 'PDF处理引擎开发工程师',
      department: '技术开发',
      location: '广州',
      type: '全职',
      experience: '5-8年',
      description: '负责PDF处理核心引擎的开发和优化，参与技术架构设计。',
      requirements: [
        '精通C++/Java编程语言',
        '熟悉PDF文档格式和处理技术',
        '有Adobe相关技术经验优先',
        '具备良好的算法和数据结构基础'
      ],
      benefits: ['五险一金', '股票期权', '技术培训', '年终奖金']
    },
    {
      id: 3,
      title: '产品经理',
      department: '产品设计',
      location: '广州',
      type: '全职',
      experience: '3-5年',
      description: '负责产品规划和设计，与技术团队协作推进产品开发。',
      requirements: [
        '有B2B产品管理经验',
        '熟悉软件开发流程',
        '具备良好的沟通和协调能力',
        '有文档处理相关经验优先'
      ],
      benefits: ['五险一金', '弹性工作', '培训机会', '年终奖金']
    },
    {
      id: 4,
      title: 'UI/UX设计师',
      department: '产品设计',
      location: '广州',
      type: '全职',
      experience: '2-4年',
      description: '负责产品界面设计和用户体验优化，制定设计规范。',
      requirements: [
        '熟练使用Figma、Sketch等设计工具',
        '有B2B产品设计经验',
        '具备良好的视觉设计能力',
        '了解前端开发技术优先'
      ],
      benefits: ['五险一金', '创意津贴', '设计培训', '年终奖金']
    },
    {
      id: 6,
      title: '企业销售经理',
      department: '销售',
      location: '广州',
      type: '全职',
      experience: '3-6年',
      description: '负责企业客户开发和维护，完成销售目标。',
      requirements: [
        '有企业级软件销售经验',
        '具备良好的客户沟通能力',
        '熟悉CRM系统使用',
        '有技术背景优先'
      ],
      benefits: ['五险一金', '高额提成', '销售培训', '年终奖金']
    }
  ];

  const benefits = [
    {
      icon: 'ri-money-dollar-circle-line',
      title: '具有竞争力的薪酬',
      description: '根据能力和贡献提供有竞争力的薪资待遇'
    },
    {
      icon: 'ri-shield-check-line',
      title: '完善的保障体系',
      description: '五险一金、商业保险、年度体检'
    },
    {
      icon: 'ri-time-line',
      title: '弹性工作制度',
      description: '灵活的工作时间和远程办公政策'
    },
    {
      icon: 'ri-graduation-cap-line',
      title: '学习发展机会',
      description: '技术培训、会议参与、职业发展规划'
    },
    {
      icon: 'ri-team-line',
      title: '团队文化',
      description: '开放包容的工作环境，鼓励创新和协作'
    },
    {
      icon: 'ri-gift-line',
      title: '员工福利',
      description: '节日礼品、团建活动、健身补贴'
    }
  ];

  const filteredJobs = selectedDepartment === '全部' 
    ? jobOpenings 
    : jobOpenings.filter(job => job.department === selectedDepartment);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-teal-600 via-cyan-600 to-teal-700 text-white py-24 overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center opacity-20"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/75e81eed18486f67f1947102015b01d3.jpg')`
          }}
        ></div>
        <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="text-5xl lg:text-6xl font-bold mb-6">
              加入<span className="text-teal-300">星允信息</span>
            </h1>
            <p className="text-xl lg:text-2xl text-gray-300 mb-8 leading-relaxed">
              与我们一起创造未来的文档智能技术，在充满挑战和机遇的环境中实现职业发展。
            </p>
            <div className="flex flex-wrap gap-4">
              <a 
                href="#positions" 
                className="bg-white text-teal-600 hover:bg-teal-50 px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
              >
                查看职位
              </a>
              <Link 
                to="/about" 
                className="border border-white hover:bg-white hover:text-teal-600 text-white px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
              >
                了解公司
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Why Join Us */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">为什么选择我们</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              我们提供优秀的工作环境和发展机会，让每一位员工都能在这里实现自己的职业目标。
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {benefits.map((benefit, index) => (
              <div key={index} className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition-shadow group">
                <div className="w-16 h-16 bg-teal-100 rounded-lg flex items-center justify-center mb-6 group-hover:bg-teal-200 transition-colors">
                  <i className={`${benefit.icon} text-2xl text-teal-600`}></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">{benefit.title}</h3>
                <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Job Openings */}
      <section id="positions" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">开放职位</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              我们正在寻找有才华的专业人士加入我们的团队，一起创造卓越的产品。
            </p>
          </div>

          {/* Department Filter */}
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            {departments.map((dept) => (
              <button
                key={dept}
                onClick={() => setSelectedDepartment(dept)}
                className={`px-6 py-3 rounded-full font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  selectedDepartment === dept
                    ? 'bg-teal-600 text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {dept}
              </button>
            ))}
          </div>

          {/* Job List */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {filteredJobs.map((job) => (
              <div key={job.id} className="bg-white border border-gray-200 rounded-lg p-8 hover:shadow-lg transition-shadow">
                <div className="flex justify-between items-start mb-6">
                  <div>
                    <h3 className="text-2xl font-semibold text-gray-900 mb-2">{job.title}</h3>
                    <div className="flex flex-wrap gap-4 text-sm text-gray-600">
                      <span className="flex items-center">
                        <i className="ri-building-line mr-1"></i>
                        {job.department}
                      </span>
                      <span className="flex items-center">
                        <i className="ri-map-pin-line mr-1"></i>
                        {job.location}
                      </span>
                      <span className="flex items-center">
                        <i className="ri-time-line mr-1"></i>
                        {job.type}
                      </span>
                      <span className="flex items-center">
                        <i className="ri-user-line mr-1"></i>
                        {job.experience}
                      </span>
                    </div>
                  </div>
                </div>

                <p className="text-gray-600 mb-6 leading-relaxed">{job.description}</p>

                <div className="mb-6">
                  <h4 className="font-semibold text-gray-900 mb-3">职位要求：</h4>
                  <ul className="space-y-2">
                    {job.requirements.map((req, index) => (
                      <li key={index} className="flex items-start text-gray-600">
                        <i className="ri-check-line text-green-500 mr-2 mt-1 flex-shrink-0"></i>
                        <span>{req}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="mb-6">
                  <h4 className="font-semibold text-gray-900 mb-3">福利待遇：</h4>
                  <div className="flex flex-wrap gap-2">
                    {job.benefits.map((benefit, index) => (
                      <span key={index} className="bg-teal-100 text-teal-800 px-3 py-1 rounded-full text-sm">
                        {benefit}
                      </span>
                    ))}
                  </div>
                </div>

                <button className="w-full bg-teal-600 hover:bg-teal-700 text-white py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
                  申请职位
                </button>
              </div>
            ))}
          </div>

          {filteredJobs.length === 0 && (
            <div className="text-center py-12">
              <i className="ri-search-line text-4xl text-gray-400 mb-4"></i>
              <p className="text-gray-600">暂无相关职位，请关注其他部门的机会。</p>
            </div>
          )}
        </div>
      </section>

      {/* Application Process */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">申请流程</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              我们的招聘流程简单透明，确保每位候选人都能得到公平的评估机会。
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {[
              {
                step: '01',
                title: '在线申请',
                description: '提交简历和求职信，我们会在3个工作日内回复。',
                icon: 'ri-file-text-line'
              },
              {
                step: '02',
                title: '初步筛选',
                description: 'HR团队会对您的背景进行初步评估和电话沟通。',
                icon: 'ri-phone-line'
              },
              {
                step: '03',
                title: '技术面试',
                description: '与团队负责人进行深入的技术和文化匹配度面试。',
                icon: 'ri-user-voice-line'
              },
              {
                step: '04',
                title: '最终决定',
                description: '我们会在面试后的5个工作日内给出最终结果。',
                icon: 'ri-check-double-line'
              }
            ].map((process, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${process.icon} text-2xl text-white`}></i>
                </div>
                <div className="text-3xl font-bold text-teal-600 mb-2">{process.step}</div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">{process.title}</h3>
                <p className="text-gray-600 leading-relaxed">{process.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-teal-600 to-cyan-600 text-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">准备好加入我们了吗？</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            如果您没有找到合适的职位，也欢迎发送简历给我们，我们会在有合适机会时联系您。
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a 
              href="mailto:hr@documogul.com" 
              className="bg-white text-teal-600 hover:bg-gray-100 px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              发送简历
            </a>
            <Link 
              to="/contact" 
              className="border border-white hover:bg-white hover:text-teal-600 text-white px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              联系我们
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
